import { useBMStore } from '../../stores/useBMStore'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { fetchBMData } from './fetchBMData'

export const useDownloadBlockedCSV = (offset = 0) => {
  const { networkId: networkIdEnc } = useUserStore()
  const { fromDate, toDate } = useBMStore((state) => state.dateRange)
  const searchQuery = useBMStore((state) => state.searchQuery)
  const advancedFilters = useBMStore((state) => state.advancedFilters)

  const downloadBlockedCSV = async () => {
    const params: Record<string, any> = {
      limit: 300,
      offset,
      'from-date': fromDate,
      'to-date': toDate,
      last3months: false,
      search: searchQuery,
      group: '',
    }

    if (advancedFilters) {
      if (advancedFilters?.threatGroups?.length === 1) {
        params['group'] = advancedFilters.threatGroups[0]
      }
      if (advancedFilters.countries?.length) params['countries'] = advancedFilters.countries
      if (advancedFilters.threatTypes?.length) params['threatTypes'] = advancedFilters.threatTypes
      if (advancedFilters.domains?.length) params['domains'] = advancedFilters.domains
    }

    try {
      return await fetchBMData<{ url: string }>('blocked/download', networkIdEnc, {
        params,
        method: 'post',
      })
    } catch (error) {
      console.error('Error downloading CSV:', error)
      throw error
    }
  }

  return { downloadBlockedCSV }
}
